import { ref } from 'vue'

export interface ConsultationFilters {
  selectedRange: Date[]
  selectedPatientsIds: string[]
}

function useCompletedConsultationFilters() {
  const filters = ref<ConsultationFilters>({
    selectedRange: [],
    selectedPatientsIds: []
  })

  function setNewFilters(newFilters: ConsultationFilters) {
    filters.value = newFilters
  }

  return {
    filters,
    setNewFilters
  }
}

export default useCompletedConsultationFilters
